import { observable } from 'mobx';

class ClassesStore {
  @observable classesList = [];
  @observable loaded = false;
}

export default new ClassesStore();
